import {
  AppInitializerFontAwesome,
  AppInitializerNgbConfig,
  AppInitializerTranslate,
  TranslateProvider,
} from './app-initializer';

export const AppInitializerProviders = [
  TranslateProvider,
  AppInitializerFontAwesome,
  AppInitializerTranslate,
  AppInitializerNgbConfig,
];
